/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AbstractFinderDialogComponent } from '@gh/common-internal-shared';
import { FormState, FormStateBuilder } from '@gh/common-shared';
import { SlicedDataSource } from '@gh/core-data';
import { TranslationService } from '@gh/core-mls';
import { getControlValue } from '@gh/core-ui';
import {
  JobSpecTemplateFinderBusinessService,
  JobSpecTemplateFinderDialogConfig,
} from '../../resources/job-spec-template-finder-business.service';
import {
  getJobSpecTemplateFinderListItemId,
  JobSpecTemplateFinderListItem,
} from '../../resources/job-spec-template-finder-list-item.model';
import { JobSpecTemplateGridDefinition } from './job-spec-template-finder-grid-definition.service';

@Component({
  standalone: false,
  selector: 'gh-job-spec-template-finder-dialog',
  templateUrl: 'job-spec-template-finder-dialog.component.html',
  styleUrls: ['job-spec-template-finder-dialog.component.scss'],
  providers: [JobSpecTemplateGridDefinition],
})
export class JobSpecTemplateFinderDialogComponent
  extends AbstractFinderDialogComponent<JobSpecTemplateFinderDialogConfig, JobSpecTemplateFinderListItem>
  implements OnInit {

  getId = getJobSpecTemplateFinderListItemId;

  form: FormState<any>;

  defaultTitle = this.translations.get('lbl_find_specification_templates');

  constructor(public gridDefinition: JobSpecTemplateGridDefinition,
              private translations: TranslationService,
              formStateBuilder: FormStateBuilder,
              private dialogRef: MatDialogRef<any>,
              private businessService: JobSpecTemplateFinderBusinessService) {
    super(dialogRef);

    this.form = formStateBuilder.buildPlain({
      children: { name: void 0 },
    });
  }

  protected buildDataSource(): SlicedDataSource<JobSpecTemplateFinderListItem> {
    return this.businessService.findAllAsDataSource({
      ...this.input.filter,
      searchString: getControlValue(this.form.group, 'name'),
      sourceOfficeId: this.input.sourceOfficeId,
    });
  }
}
